import type { ICoordinates, Sample } from 'Model/index.ts'
import type { ISampleMetaData } from 'Model/Sample/ISampleMetaData.ts'
import { useState } from 'react'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

import icon from 'leaflet/dist/images/marker-icon.png'

import iconShadow from 'leaflet/dist/images/marker-shadow.png'
import Map from './Map.tsx'
import React from 'react'

const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41], // size of the icon
  iconAnchor: [12.5, 41]
})

L.Marker.prototype.options.icon = DefaultIcon

interface SamplesMapProps {
  samples: Sample[]
  metaData: ISampleMetaData[]
}

const SamplesMap = (props: SamplesMapProps & React.HTMLAttributes<HTMLDivElement>) => {
  const [pointIntensity, setPointIntensity] = useState(5)

  return (
    <Map
      className={props.className}
      style={props.style}
      objects={props.samples
        .filter((s) => !!s.sampleMetadata && !!s.sampleMetadata.sampleCoordinates)
        .map((s) => s as Sample & { sampleMetadata: ISampleMetaData & { sampleCoordinates: ICoordinates } })}
      getCoordinates={(obj) => obj.sampleMetadata.sampleCoordinates.coordinates}
      getIntensity={() => pointIntensity}
      getMarkerLabel={(obj) => obj.customerSampleName || 'N/A'}
      renderControls={() => (
        <div className="dropdown absolute right-8 z-100">
          <div tabIndex={0} role="button" className="btn m-1 btn-sm">
            Intensity
          </div>
          <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-1 p-2 shadow-sm w-full">
            <input
              type="range"
              min={0}
              max="400"
              className="range range-xs range-primary w-full"
              value={pointIntensity}
              onChange={(e) => setPointIntensity(Number(e.target.value))}
            />
          </ul>
        </div>
      )}
    />
  )
}
export default SamplesMap
